import React from 'react'
import Search from './Search'
import { logo } from '../images/index'

const Header = ({ ...props }) => {
	return (
		<div className='mb-6'>
			<div className=' -ml-5 mb-7'>
				<img src={logo} alt='' />
			</div>
			<Search setShowSearchPage={props.setShowSearchPage} setCategoryID={props.setCategoryID}></Search>
		</div>
	)
}

export default Header
